import React, {
  CSSProperties, ReactNode, useEffect, useRef, useState,
} from 'react';
import styled from 'styled-components';

import { TextMediumStyle, TextRegStyle } from '~/atomic/Typography';
import { Linkify } from '~/feature/utils/Linkify';
import { environments } from '~/lib/const';

import { breakepoints } from '../breakepoints';

interface ReadMoreProps extends React.HTMLAttributes<HTMLSpanElement> {
  text: string | ReactNode;
  linkOpen?: string | ReactNode;
  linkClose?: string | ReactNode;
  linkStyle?: CSSProperties;
  isOnlyMobile?: boolean;
  maxHeight?: number;
}

export const ReadMore = ({
  text, linkOpen, maxHeight, linkClose, isOnlyMobile, linkStyle, ...spanProps
}: ReadMoreProps) => {
  const MAX_HEIGHT = maxHeight || 70;
  const isDesktop = environments.isClient
    ? window.innerWidth > breakepoints['screen-sm-down-raw']
    : true;

  const textRef = useRef<HTMLDivElement>(null);
  const [isShowLink, setShowLink] = useState(false);
  const [mainHeight, setMainHeight] = useState(MAX_HEIGHT);
  const [open, setOpen] = useState(false);

  const readMoreHandler = () => {
    setMainHeight(open ? MAX_HEIGHT : textRef.current.offsetHeight);
    setOpen((open) => !open);
  };

  useEffect(() => {
    if (environments.isClient) {
      const textHeight = textRef.current?.offsetHeight;

      if (textHeight > MAX_HEIGHT) {
        setShowLink(true);
      }
    }
  }, []);

  if (isDesktop && isOnlyMobile) {
    return (
      <SCWrapText
        {...spanProps}
      >
        {text}
      </SCWrapText>
    );
  }

  const renderLink = () => {
    if (!isShowLink) return null;
    return (
      <SCLink
        onClick={readMoreHandler}
        style={linkStyle}
      >
        {open
          ? linkClose || 'Закрыть'
          : linkOpen || 'Подробнее'}
      </SCLink>
    );
  };

  return (
    <Linkify>
      <SCReadMore>
        <SCMain
          style={{ maxHeight: `${mainHeight}px` }}
        >
          <SCWrapText
            ref={textRef}
            {...spanProps}
          >
            {text}
          </SCWrapText>
        </SCMain>
        {renderLink()}
      </SCReadMore>
    </Linkify>
  );
};

const SCWrapText = styled.span`
  ${TextRegStyle};
  color: var(--black-color);
  margin-bottom: 12px;
  white-space: pre-line;
  word-break: break-word;
`;

const SCMain = styled.div`
  overflow: hidden;
  transition: all 0.3s ease;
`;

const SCReadMore = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SCLink = styled.span`
  ${TextMediumStyle};
  color: var(--primary-color);
  margin-top: 12px;
  cursor: pointer;

  &:hover {
    color: var(--primary-hover-color);
  }
`;
